import React from 'react';
import { Typography } from 'antd';
import EventList from '../components/EventList';

const { Title } = Typography;

const Event: React.FC = () => (
  <div>
    <Title level={4} style={{ fontWeight: 'bold' }}>Events</Title>
    <div style={{ marginTop: 32 }}>
      <EventList />
    </div>
  </div>
);

export default Event;
